<template>
    <div>
        <router-view />
    </div>
  </template>
  
  <script>
  import { mixinDevice } from "@/utils/mixin.js";
  export default {
    name: "examinationLayout",
    mixins: [mixinDevice],
    components: {},
    data() {
      return {
      };
    },
    created() {
  
    },
  };
  </script>
  <style lang="less" scoped>
  </style>